export const FiveSixKLessons = [
  {
    lessonNumber: 1,
    lessonTitle: "A Strange Night in a Quiet Suburban Neighbourhood",

    PreKoreanWord1: "It was quiet as if people felt",
    KoreanWord1: "무관심",
    KoreanWord1EngTranslation: "indifference",
    PostKoreanWord1: "toward the world at night.",

    PreKoreanWord2: "The stars began to",
    KoreanWord2: "반짝이다",
    KoreanWord2EngTranslation: "twinkle",
    PostKoreanWord2: "as the night got darker.",

    PreKoreanWord3: "A motorbike passed by — food",
    KoreanWord3: "배달",
    KoreanWord3EngTranslation: "delivery",
    PostKoreanWord3: "heading down the block.",

    PreKoreanWord4: "I sat on my porch thinking about a",
    KoreanWord4: "번역",
    KoreanWord4EngTranslation: "translation",
    PostKoreanWord4: "assignment I still hadn’t finished.",

    PreKoreanWord5: "My neighbor came out, but his",
    KoreanWord5: "부인",
    KoreanWord5EngTranslation: "wife",
    PostKoreanWord5: "quickly called him back in.",

    PreKoreanWord6: "The street suddenly became",
    KoreanWord6: "분주하다",
    KoreanWord6EngTranslation: "busy",
    PostKoreanWord6: "with several cars returning home at once.",

    PreKoreanWord7: "A gust of wind blew a",
    KoreanWord7: "비닐봉지",
    KoreanWord7EngTranslation: "plastic bag",
    PostKoreanWord7: "across the road, dancing like a little ghost.",

    PreKoreanWord8: "I remembered the",
    KoreanWord8: "비판적",
    KoreanWord8EngTranslation: "critical",
    PostKoreanWord8:
      "comments my friend made about this place being “too boring”.",

    PreKoreanWord9: "I reached to grab my keys but my dog tried to",
    KoreanWord9: "뺏다",
    KoreanWord9EngTranslation: "snatch",
    PostKoreanWord9: "them from me.",

    PreKoreanWord10: "I unlocked the door and checked my old",
    KoreanWord10: "사전",
    KoreanWord10EngTranslation: "dictionary",
    PostKoreanWord10: "out of nostalgia.",

    PreKoreanWord11:
      "In the hallway, I slid a packet of letters into the bottom",
    KoreanWord11: "서랍",
    KoreanWord11EngTranslation: "drawer",
    PostKoreanWord11: "to deal with later.",

    PreKoreanWord12: "Suddenly, a short, loud",
    KoreanWord12: "소나기",
    KoreanWord12EngTranslation: "shower",
    PostKoreanWord12: "started, surprising me.",

    PreKoreanWord13: "I held my grandmother’s",
    KoreanWord13: "소중히",
    KoreanWord13EngTranslation: "preciously",
    PostKoreanWord13: "ring as I gazed out the window.",

    PreKoreanWord14: "I used the",
    KoreanWord14: "손잡이",
    KoreanWord14EngTranslation: "handle",
    PostKoreanWord14: "to shut the window.",

    PreKoreanWord15: "In the kitchen, the",
    KoreanWord15: "수도꼭지",
    KoreanWord15EngTranslation: "faucet",
    PostKoreanWord15: "dripped steadily in the dark.",

    PreKoreanWord16: "I don't want to be",
    KoreanWord16: "실례",
    KoreanWord16EngTranslation: "rude",
    PostKoreanWord16: "and make noise at this time of night.",

    PreKoreanWord17: "I've got a",
    KoreanWord17: "싸구려",
    KoreanWord17EngTranslation: "cheap",
    PostKoreanWord17: "blanket to keep me warm.",

    PreKoreanWord18: "A child outside waved and said",
    KoreanWord18: "안녕",
    KoreanWord18EngTranslation: "hello",
    PostKoreanWord18: "to me through the rain.",

    PreKoreanWord19: "The lights flickered again, threatening to",
    KoreanWord19: "안되다",
    KoreanWord19EngTranslation: "fail",
    PostKoreanWord19: "completely.",

    PreKoreanWord20: "I got medicine from the",
    KoreanWord20: "약국",
    KoreanWord20EngTranslation: "pharmacy",
    PostKoreanWord20: "and I keep it just in case.",

    PreKoreanWord21: "The storm was",
    KoreanWord21: "어찌나",
    KoreanWord21EngTranslation: "so (intensely)",
    PostKoreanWord21: "loud that I couldn’t hear the TV.",

    PreKoreanWord22: "But the weather report turned out to be completely",
    KoreanWord22: "엉터리",
    KoreanWord22EngTranslation: "nonsense",
    PostKoreanWord22: "anyway.",

    PreKoreanWord23: "My tea tasted pleasantly",
    KoreanWord23: "연하다",
    KoreanWord23EngTranslation: "mild",
    PostKoreanWord23: "— just the way I like it.",

    PreKoreanWord24: "Through the window, I saw a small",
    KoreanWord24: "원숭이",
    KoreanWord24EngTranslation: "monkey",
    PostKoreanWord24: "swing from a tree.",

    PreKoreanWord25: "I got a message on my phone about",
    KoreanWord25: "위법",
    KoreanWord25EngTranslation: "illegal",
    PostKoreanWord25: "parking on our street.",

    PreKoreanWord26: "My back felt sore — too much sitting and not enough",
    KoreanWord26: "육체적",
    KoreanWord26EngTranslation: "physical",
    PostKoreanWord26: "movement recently.",

    PreKoreanWord27:
      "A calendar on the wall showed today’s date in both solar and",
    KoreanWord27: "음력",
    KoreanWord27EngTranslation: "lunar calendar",
    PostKoreanWord27: "formats.",

    PreKoreanWord28: "I heard a neighbor arguing about their recent",
    KoreanWord28: "이혼",
    KoreanWord28EngTranslation: "divorce",
    PostKoreanWord28: "settlement.",

    PreKoreanWord29: "The kitchen had too many",
    KoreanWord29: "일회용",
    KoreanWord29EngTranslation: "single-use",
    PostKoreanWord29: "cups piling up — I need to recycle.",

    PreKoreanWord30: "The rain soaked the",
    KoreanWord30: "잔디밭",
    KoreanWord30EngTranslation: "lawn",
    PostKoreanWord30: "in the backyard completely.",

    PreKoreanWord31: "A voice called out from",
    KoreanWord31: "저기",
    KoreanWord31EngTranslation: "over there",
    PostKoreanWord31: "near the fence asking for help.",

    PreKoreanWord32: "It was a nurse, who works in a",
    KoreanWord32: "전문직",
    KoreanWord32EngTranslation: "professional",
    PostKoreanWord32: "field.",

    PreKoreanWord33: "She had dropped her",
    KoreanWord33: "전화기",
    KoreanWord33EngTranslation: "telephone",
    PostKoreanWord33: "while bringing groceries inside.",

    PreKoreanWord34: "She asked if I could help her to",
    KoreanWord34: "제출",
    KoreanWord34EngTranslation: "submit",
    PostKoreanWord34: "a form online.",

    PreKoreanWord35: "We briefly talked about the strange events of",
    KoreanWord35: "지난주",
    KoreanWord35EngTranslation: "last week",
    PostKoreanWord35: "when the power went out.",

    PreKoreanWord36: "Her garden had blooming",
    KoreanWord36: "진달래",
    KoreanWord36EngTranslation: "azaleas",
    PostKoreanWord36: "even in the rain.",

    PreKoreanWord37: "She pointed toward the right-hand",
    KoreanWord37: "쪽",
    KoreanWord37EngTranslation: "side",
    PostKoreanWord37: "of the fence where the noise came from.",

    PreKoreanWord38: "The air was warm and humid, almost like buns",
    KoreanWord38: "찌다",
    KoreanWord38EngTranslation: "steaming",
    PostKoreanWord38: "in the kitchen.",

    PreKoreanWord39: "From the neighbor’s house, their",
    KoreanWord39: "차남",
    KoreanWord39EngTranslation: "second son",
    PostKoreanWord39: "peeked out curiously at us.",

    PreKoreanWord40: "He said he doesn't like the",
    KoreanWord40: "채점",
    KoreanWord40EngTranslation: "grading",
    PostKoreanWord40: "at school.",

    PreKoreanWord41: "I told him to stay",
    KoreanWord41: "침착하다",
    KoreanWord41EngTranslation: "calm",
    PostKoreanWord41: "even if he gets upset.",

    PreKoreanWord42: "Suddenly, the entire neighborhood went",
    KoreanWord42: "캄캄하다",
    KoreanWord42EngTranslation: "pitch dark",
    PostKoreanWord42: "as the lights shut off.",

    PreKoreanWord43: "The nurse handed me an old",
    KoreanWord43: "타자기",
    KoreanWord43EngTranslation: "typewriter",
    PostKoreanWord43: "she wanted to donate, smiling in the darkness.",

    PreKoreanWord44: "I could just about see",
    KoreanWord44: "팬티",
    KoreanWord44EngTranslation: "underwear",
    PostKoreanWord44: "drying on the line.",

    PreKoreanWord45: "I just wanted to rest",
    KoreanWord45: "편히",
    KoreanWord45EngTranslation: "comfortably",
    PostKoreanWord45: "on the sofa.",

    PreKoreanWord46: "A small app notification gave me extra reward",
    KoreanWord46: "포인트",
    KoreanWord46EngTranslation: "points",
    PostKoreanWord46: "for a completed order.",

    PreKoreanWord47: "In the kitchen, I grabbed a",
    KoreanWord47: "포크",
    KoreanWord47EngTranslation: "fork",
    PostKoreanWord47: "to eat some leftover cake.",

    PreKoreanWord48: "Hours passed, and it was suddenly",
    KoreanWord48: "한밤중",
    KoreanWord48EngTranslation: "midnight",
    PostKoreanWord48: "without me noticing.",

    PreKoreanWord49: "I thought about visiting my parents more — I should be",
    KoreanWord49: "효도",
    KoreanWord49EngTranslation: "filial",
    PostKoreanWord49: "while I still can.",

    PreKoreanWord50: "I locked the door, looked around at all my old",
    KoreanWord50: "가구",
    KoreanWord50EngTranslation: "furniture",
    PostKoreanWord50: "and finally went to sleep.",
  },
  {
    lessonNumber: 2,
    lessonTitle: "The Girl Goes on Holiday",

    PreKoreanWord1: "The",
    KoreanWord1: "간호사",
    KoreanWord1EngTranslation: "nurse",
    PostKoreanWord1: "finished her shift and knew she needed a holiday.",

    PreKoreanWord2: "Outside her apartment",
    KoreanWord2: "개나리",
    KoreanWord2EngTranslation: "forsythia",
    PostKoreanWord2: "were blooming just like in spring.",

    PreKoreanWord3: "A",
    KoreanWord3: "고등학생",
    KoreanWord3EngTranslation: "high school student",
    PostKoreanWord3: "helped her carry her suitcase to the street.",

    PreKoreanWord4: "She walked through a quiet",
    KoreanWord4: "골목길",
    KoreanWord4EngTranslation: "alleyway",
    PostKoreanWord4: "on her way to catch a taxi.",

    PreKoreanWord5: "There were many",
    KoreanWord5: "관람객",
    KoreanWord5EngTranslation: "spectators / tourists",
    PostKoreanWord5: "heading to tourist spots.",

    PreKoreanWord6: "She rarely had the energy to do anything except",
    KoreanWord6: "귀가",
    KoreanWord6EngTranslation: "go home",
    PostKoreanWord6: "after work.",

    PreKoreanWord7: "But today she felt excited, she wouldn't",
    KoreanWord7: "그리워하다",
    KoreanWord7EngTranslation: "miss",
    PostKoreanWord7: "the stressful days.",

    PreKoreanWord8: "She suddenly",
    KoreanWord8: "기억나다",
    KoreanWord8EngTranslation: "remembered",
    PostKoreanWord8: "that her friend lived near the beach.",

    PreKoreanWord9: "On the bus, a man kept",
    KoreanWord9: "기침",
    KoreanWord9EngTranslation: "coughing",
    PostKoreanWord9: "loudly, so she moved seats.",

    PreKoreanWord10: "The driver played happy",
    KoreanWord10: "노랫소리",
    KoreanWord10EngTranslation: "singing / melody",
    PostKoreanWord10: "from the radio.",

    PreKoreanWord11: "She planned to stay at the beach for",
    KoreanWord11: "다섯",
    KoreanWord11EngTranslation: "five",
    PostKoreanWord11: "days.",

    PreKoreanWord12: "She couldn't wait to eat",
    KoreanWord12: "닭고기",
    KoreanWord12EngTranslation: "chicken",
    PostKoreanWord12: "and vegetables.",

    PreKoreanWord13: "A friendly",
    KoreanWord13: "대학교수",
    KoreanWord13EngTranslation: "university professor",
    PostKoreanWord13: "sat next to her and talked about travel.",

    PreKoreanWord14: "When they arrived, the professor used the",
    KoreanWord14: "뒷문",
    KoreanWord14EngTranslation: "back door",
    PostKoreanWord14: "to exit the bus quickly.",

    PreKoreanWord15: "At the beach town, a little",
    KoreanWord15: "딸아이",
    KoreanWord15EngTranslation: "little daughter",
    PostKoreanWord15: "ran past holding an ice cream.",

    PreKoreanWord16: "At a café, the nurse drank water with a slice of",
    KoreanWord16: "레몬",
    KoreanWord16EngTranslation: "lemon",
    PostKoreanWord16: "with it.",

    PreKoreanWord17: "The peaceful seaside air felt truly",
    KoreanWord17: "만족스럽다",
    KoreanWord17EngTranslation: "satisfying",
    PostKoreanWord17: "after life in the city.",

    PreKoreanWord18: "She came here to let go of stress, not to feel",
    KoreanWord18: "미움",
    KoreanWord18EngTranslation: "hatred / resentment",
    PostKoreanWord18: "or frustration.",

    PreKoreanWord19: "At her hotel she used a",
    KoreanWord19: "바가지",
    KoreanWord19EngTranslation: "dipper / small bowl",
    PostKoreanWord19: "to rinse her hair.",

    PreKoreanWord20: "She walked along the beach until her",
    KoreanWord20: "발끝",
    KoreanWord20EngTranslation: "toes",
    PostKoreanWord20: "were in the water.",

    PreKoreanWord21: "She waded into the sea until her",
    KoreanWord21: "배꼽",
    KoreanWord21EngTranslation: "belly button",
    PostKoreanWord21: "touched the cold water.",

    PreKoreanWord22: "She saw a patient coming out of the",
    KoreanWord22: "병실",
    KoreanWord22EngTranslation: "hospital room",
    PostKoreanWord22: "to enjoy the sea.",

    PreKoreanWord23: "There was a man on the beach",
    KoreanWord23: "봉사하다",
    KoreanWord23EngTranslation: "volunteering",
    PostKoreanWord23: "to be a life guard.",

    PreKoreanWord24: "Over the hill at the",
    KoreanWord24: "비행장",
    KoreanWord24EngTranslation: "airfield",
    PostKoreanWord24: "a plane took off.",

    PreKoreanWord25: "A mother was taking her",
    KoreanWord25: "사랑스럽다",
    KoreanWord25EngTranslation: "lovely",
    PostKoreanWord25: "child for a walk.",

    PreKoreanWord26: "The nurse stopped to eat with a",
    KoreanWord26: "숟가락",
    KoreanWord26EngTranslation: "spoon",
    PostKoreanWord26: "and fork.",

    PreKoreanWord27: "At the next table, a tourist knocked over a",
    KoreanWord27: "술병",
    KoreanWord27EngTranslation: "liquor bottle",
    PostKoreanWord27: "accidentally.",

    PreKoreanWord28: "The sea air was filled with",
    KoreanWord28: "습기",
    KoreanWord28EngTranslation: "humidity",
    PostKoreanWord28: "and warmth.",

    PreKoreanWord29: "She thought about buying a postcard and",
    KoreanWord29: "쓰이다",
    KoreanWord29EngTranslation: "be written",
    PostKoreanWord29: "a message on it.",

    PreKoreanWord30: "She decided to buy a",
    KoreanWord30: "엽서",
    KoreanWord30EngTranslation: "postcard",
    PostKoreanWord30: "to send to her friend.",

    PreKoreanWord31: "The weather",
    KoreanWord31: "예보",
    KoreanWord31EngTranslation: "forecast",
    PostKoreanWord31: "said the weekend would be sunny.",

    PreKoreanWord32: "She forgot what",
    KoreanWord32: "요일",
    KoreanWord32EngTranslation: "day of the week",
    PostKoreanWord32: "it was but didn’t care.",

    PreKoreanWord33: "Her hotel room had a clean",
    KoreanWord33: "욕실",
    KoreanWord33EngTranslation: "bathroom",
    PostKoreanWord33: "with flowers in it.",

    PreKoreanWord34: "She felt",
    KoreanWord34: "용감하다",
    KoreanWord34EngTranslation: "brave",
    PostKoreanWord34: "enough to rent a scooter.",

    PreKoreanWord35: "The scooter was driven by a friendly",
    KoreanWord35: "운전기사",
    KoreanWord35EngTranslation: "driver",
    PostKoreanWord35: ".",

    PreKoreanWord36: "He warned her about the",
    KoreanWord36: "위험성",
    KoreanWord36EngTranslation: "danger",
    PostKoreanWord36: "of slippery seaside roads.",

    PreKoreanWord37: "The fruit at the market was freshly",
    KoreanWord37: "익다",
    KoreanWord37EngTranslation: "ripe",
    PostKoreanWord37: "and sweet.",

    PreKoreanWord38: "She remembered she still had some hospital",
    KoreanWord38: "일",
    KoreanWord38EngTranslation: "work",
    PostKoreanWord38: "waiting back home — but not today.",

    PreKoreanWord39: "The",
    KoreanWord39: "장마",
    KoreanWord39EngTranslation: "rainy season",
    PostKoreanWord39: "was due to start so wet weather is expected.",

    PreKoreanWord40: "A young student said he was",
    KoreanWord40: "재학",
    KoreanWord40EngTranslation: "enrolled",
    PostKoreanWord40: "at a local school.",

    PreKoreanWord41: "She was happy, “",
    KoreanWord41: "저",
    KoreanWord41EngTranslation: "I (formal)",
    PostKoreanWord41: " am on vacation now!”",

    PreKoreanWord42: "She walked past a store selling small",
    KoreanWord42: "전기",
    KoreanWord42EngTranslation: "electric",
    PostKoreanWord42: "fans.",

    PreKoreanWord43: "A local artist had set up a stall to",
    KoreanWord43: "전시하다",
    KoreanWord43EngTranslation: "exhibit",
    PostKoreanWord43: "her paintings.",

    PreKoreanWord44: "The nurse decided she needed a",
    KoreanWord44: "정기적",
    KoreanWord44EngTranslation: "regular",
    PostKoreanWord44: "holiday like this every year.",

    PreKoreanWord45: "She saw a temple preparing for a",
    KoreanWord45: "종교적",
    KoreanWord45EngTranslation: "religious",
    PostKoreanWord45: "festival.",

    PreKoreanWord46: "She knows that everyone has their own",
    KoreanWord46: "주관적",
    KoreanWord46EngTranslation: "subjective",
    PostKoreanWord46: "idea of a good holiday.",

    PreKoreanWord47: "A tired",
    KoreanWord47: "직장인",
    KoreanWord47EngTranslation: "office worker",
    PostKoreanWord47: "sat near her drinking iced tea.",

    PreKoreanWord48: "The nurse felt a warm feeling of",
    KoreanWord48: "진심",
    KoreanWord48EngTranslation: "sincerity",
    PostKoreanWord48: "for this peaceful place.",

    PreKoreanWord49: "She thought about",
    KoreanWord49: "질문하다",
    KoreanWord49EngTranslation: "asking",
    PostKoreanWord49: "when was a good time to come again.",

    PreKoreanWord50: "Sadly, time was",
    KoreanWord50: "짧아지다",
    KoreanWord50EngTranslation: "shortening",
    PostKoreanWord50: "and she'd have to leave soon.",
  },
];
